import { Instance, types } from "mobx-state-tree";
import { BaseChatItem } from "./BaseChatItem";

/**
 * Base model for all ChatItem subtypes containing static text content
 */
export const TextChatItem = types.compose(
  "TextChatItem",
  BaseChatItem,
  types.model({
    text: types.string
  })
);

export interface ITextChatItem extends Instance<typeof TextChatItem> {}
